import styled from 'styled-components';
import colors from 'common/styles/colors';

export const ShellRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: calc(100vh - var(--title-bar-offset, 0px) - 120px);
  max-height: calc(100vh - var(--title-bar-offset, 0px) - 120px);
  overflow: hidden;
  background: ${colors.greyXXXL};
  border-top: 1px solid ${colors.greyL};

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: unset;
    max-height: unset;
    overflow: auto;
  }
`;

export const Sidebar = styled.aside`
  width: 280px;
  min-width: 260px;
  border-right: 1px solid ${colors.greyL};
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 2px 0 16px rgba(15, 23, 42, 0.04);

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
    border-right: none;
    border-bottom: 1px solid ${colors.greyL};
    box-shadow: 0 2px 16px rgba(15, 23, 42, 0.04);
  }
`;

export const SidebarBrand = styled.div`
  padding: 16px 18px 12px;
  border-bottom: 1px solid ${colors.greyL};
  font-family: 'Petasense Open Sans', sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: ${colors.black};
  line-height: 1.3;
`;

export const SidebarSection = styled.div`
  padding: 12px 0 8px;
  flex: ${props => (props.$flex ? '1' : '0 0 auto')};
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SidebarSectionTitle = styled.div`
  padding: 0 18px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.greyXD};
`;

export const SidebarScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 8px 12px 12px;
`;

export const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: ${colors.white};
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px 20px;
  padding: 14px 20px 10px;
  border-bottom: 1px solid ${colors.greyL};
  background: ${colors.white};
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.03);
`;

export const TopBarCluster = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 16px;
  flex: 1;
  min-width: 0;
`;

export const BreadcrumbText = styled.div`
  font-size: 14px;
  color: ${colors.greyXXD};
  & strong {
    color: ${colors.black};
    font-weight: 600;
  }
`;

export const BadgeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const StatusPill = styled.span`
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid ${colors.greyL};
  background: ${props => props.$bg || colors.greyXL};
  color: ${props => props.$fg || colors.black};
`;

export const CriticalityPill = styled.span`
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${colors.greyXXD};
  color: ${colors.white};
`;

export const TabsSlot = styled.div`
  padding: 0 12px;
  .ui.secondary.menu {
    border-bottom: 1px solid ${colors.greyL};
  }
`;

export const ContentSlot = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: ${props => (props.$flexFill ? 'hidden' : 'auto')};
  display: ${props => (props.$flexFill ? 'flex' : 'block')};
  flex-direction: ${props => (props.$flexFill ? 'column' : 'initial')};
  padding: ${props => (props.$noPadding ? '0' : '16px 20px')};
  background: ${colors.greyXXXL};
`;
